export const TypeLoc = 'loc';
export const TypeMap = 'map';
export const TypeSat = 'sat';
